import React from "react";
import { connect } from "react-redux";
import HeaderBarGroupsPortal from "./components/header/HeaderBarGroupsPortal";
import MainRouter from "./components/MainRouter";
import { FullPageLoader, CernFooter } from "@authzsvc/common-react-components";
import GroupActionsMenu from "./components/header/GroupActionsMenu";
import TitleProvider from "./components/title/TitleProvider";
import AppInitializer from "./components/AppInitializer";
import { Layout } from "antd";

const App = ({ ready }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {ready ? (
        <TitleProvider>
          <Layout style={{ minHeight: "100vh", backgroundColor: "white" }}>
            <Layout.Header
              style={{
                position: "sticky",
                zIndex: 11,
                display: "flex",
                flexDirection: "column",
                gap: "8px", // optional spacing
              }}
            >
              <AppInitializer />
              <HeaderBarGroupsPortal />
            </Layout.Header>
            <Layout.Content>
              <GroupActionsMenu />
              <MainRouter />
            </Layout.Content>
          </Layout>
          <Layout.Footer style={{ padding: "0px" }}>
            <CernFooter
              requestLink="https://cern.service-now.com/service-portal?id=functional_element&name=GMS"
              incidentLink="https://cern.service-now.com/service-portal?id=functional_element&name=GMS"
              documentationLink="https://auth.docs.cern.ch/groups/overview/"
            />
          </Layout.Footer>
        </TitleProvider>
      ) : (
        <FullPageLoader />
      )}
    </div>
  );
};

export default connect((state) => ({
  ready: state.keycloak.ready,
  sidebarVisible: state.sidebar.visible,
}))(App);
